var TimeModeShareRedirector = xClass("TimeModeShareRedirector", BaseRedirector)
StrategyConfrim = null;
TimeModeShareRedirector.prototype.getName = function () {
    return "timeModeShare";
}
TimeModeShareRedirector.prototype.hasHighPriorityAction = function() {
    return false;
}
TimeModeShareRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    if (um.uid && param.inviteCode && param.shareId) {
        let http = TimeMatchAddTimeShareClickHttp.new();
        http.addEventListener(Events.kComplete, () => {
            Toast.make(getText("time.match.help.succeed"));
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            cc.log(evt.data);
            Toast.make(quickGetErrorText(evt.data, "链接已经失效！"));
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}

module.exports = TimeModeShareRedirector